// removed by extract-text-webpack-plugin
module.exports = {"root":"Page__root__2VuHt","content":"Page__content__rCsmc","scrollingDisabled":"Page__scrollingDisabled__1UDip"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/Page.css
// module id = 2050
// module chunks = 0